/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { createRef, useState } from 'react';
import { string } from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const styles = makeStyles((theme) => ({
    moreAbout: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        outlineColor: '#CCC',
        margin: '30px 0',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    plusIcon: {
        height: '26px',
        marginBottom: '0',
        width: '26px',
        '&:hover': {
            textDecoration: 'none',
        },
        [theme.breakpoints.down(600)]: {
            height: '20px',
        },
    },
    footerContainer: {
        overflow: 'hidden',
        transition: 'height 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    },
    footerBody: {
        textAlign: 'left',
        paddingLeft: '15px',
        paddingRight: '15px',
        fontSize: '14px',
        maxWidth: '1400px',
        margin: '0 auto',
        letterSpacing: '.03em',
        WebkitFontSmoothing: 'antialiased',
        '& h1, h2': {
            width: '100%',
            color: theme.palette.sectionHeaderTextColor,
            fontFamily: theme.typography.fontFamily,
            margin: '0',
            padding: '15px',
            fontSize: '14px',
            whiteSpace: 'normal',
            background: theme.palette.colorNeutral30,
        },
        '& h2': {
            '& ul': {
                boxSizing: 'content-box',
            },
        },
        '& p': {
            padding: '0 15px',
            color: theme.palette.sectionHeaderTextColor,
            lineHeight: '1.5',
        },
        '& a': {
            color: theme.palette.cms?.primary || theme.palette.colorPrimary,
        },
        '& ul': {
            lineHeight: '1.5',
            color: theme.palette.sectionHeaderTextColor,
        },
    },
}));

const Footer = ({ disclaimer }) => {
    const classes = styles();

    const transEnd = createRef();
    const heightRef = createRef();

    const [divHeight, setDivHeight] = useState('auto');
    const [isExpanded, setIsExpanded] = useState(true);

    const currentHeight = isExpanded ? divHeight : 0;

    if (!disclaimer || disclaimer?.length === 0) return null;

    const showMoreText = () => {
        setIsExpanded((prevState) => (!prevState));
        setDivHeight(heightRef.current.clientHeight);
    };

    return (
        <div data-testid="footer" id="disclaimer">
            <div
                tabIndex="0"
                role="button"
                onClick={showMoreText}
                onKeyDown={showMoreText}
                className={classes.moreAbout}
            >
                {!isExpanded ? <AddIcon /> : <RemoveIcon />}
            </div>
            <div
                className={classes.footerContainer}
                style={{ height: `${currentHeight}px` }}
                ref={transEnd}
            >
                <div className={classes.footerBody} ref={heightRef}>
                    <ReactMarkdown
                        source={disclaimer}
                        skipHtml
                    />
                </div>
            </div>
        </div>
    );
};

Footer.propTypes = {
    disclaimer: string.isRequired,
};

export default Footer;
